// Jauge circulaire de certitude.
// Affiche la probabilité maximale (P(top morphologie)) en pourcentage,
// avec un arc SVG animé et la lettre de la morphologie au centre.

import type { Morphology } from '../engine/types';

const SIZE = 96;
const STROKE = 8;
const RADIUS = (SIZE - STROKE) / 2;
const CIRC = 2 * Math.PI * RADIUS;

export function createGauge(): { el: HTMLElement; update: (m: Morphology, conf: number) => void } {
  const wrap = document.createElement('div');
  wrap.className = 'eteka-gauge';
  wrap.innerHTML = `
    <svg viewBox="0 0 ${SIZE} ${SIZE}" width="${SIZE}" height="${SIZE}" aria-label="Certitude de classification">
      <circle class="eteka-gauge-bg" cx="${SIZE / 2}" cy="${SIZE / 2}" r="${RADIUS}"
              fill="none" stroke-width="${STROKE}" />
      <circle class="eteka-gauge-fg" cx="${SIZE / 2}" cy="${SIZE / 2}" r="${RADIUS}"
              fill="none" stroke-width="${STROKE}" stroke-linecap="round"
              stroke-dasharray="${CIRC}" stroke-dashoffset="${CIRC}"
              transform="rotate(-90 ${SIZE / 2} ${SIZE / 2})" />
      <text class="eteka-gauge-letter" x="50%" y="46%" text-anchor="middle" dominant-baseline="middle">?</text>
      <text class="eteka-gauge-percent" x="50%" y="72%" text-anchor="middle" dominant-baseline="middle">0%</text>
    </svg>
  `;
  const fg = wrap.querySelector<SVGCircleElement>('.eteka-gauge-fg')!;
  const letterEl = wrap.querySelector<SVGTextElement>('.eteka-gauge-letter')!;
  const pctEl = wrap.querySelector<SVGTextElement>('.eteka-gauge-percent')!;

  function update(m: Morphology, conf: number) {
    const clamped = Math.max(0, Math.min(1, conf));
    fg.style.strokeDashoffset = String(CIRC * (1 - clamped));
    letterEl.textContent = m;
    pctEl.textContent = `${Math.round(clamped * 100)}%`;
    wrap.dataset.confidence = clamped >= 0.85 ? 'high' : clamped >= 0.6 ? 'mid' : 'low';
  }

  return { el: wrap, update };
}
